<template>
    <div>
        <b-row class="pmis-container row-eq-height igrala-background">
            <b-col class="igrala-title" sm="12"><h2>Igrala</h2></b-col>
            <PmisSolution name="thingsBoard" idx="1">ThingsBoard</PmisSolution>
            <PmisSolution name="orange" idx="2">Orange</PmisSolution>
            <PmisSolution name="wso2" idx="3">WSO2</PmisSolution>
            <PmisSolutionEmpty>Dodaj svojo rešitev</PmisSolutionEmpty>
        </b-row>
        <b-row class="igrala-features igrala-background">
            <b-col class="igrala-desc-offset" lg="6" md="12">
                <pmis-osnovna-vsebina-desc  :title="title" :description="htmlDescription"></pmis-osnovna-vsebina-desc>
            </b-col>
            <b-col lg="6" md="12">
                <pmis-features></pmis-features>
            </b-col>
        </b-row>
    </div>

</template>

<script>
    import PmisSolution from "./solution/PlaygroundSolution";
    import PmisSolutionEmpty from "./solution/PlaygroundSolutionEmpty";
    import PmisFeatures from "./feature/PmisFeatures";
    import PmisOsnovnaVsebinaDesc from "./../presentation/desc/PmisOsnovnaVsebinaDesc";

    export default {
        name: "PmisIgrala",
        components: {PmisFeatures, PmisSolutionEmpty, PmisOsnovnaVsebinaDesc, PmisSolution},
        computed: {
            title() {
                return "Druga igrala";
            },
            htmlDescription() {
                return "Želite, da je v igralnici tudi vaša rešitev? Pišite nam\n" +
                    "                na <span class='expose'>info@pmis.si</span> in posredovali vam bomo pogoje\n" +
                    "                za vključitev. Med primerna druga igrala sodijo <span class='expose'>okolja</span>,\n" +
                    "                <span class='expose'>platforme</span> in <span class='expose'>rešitve</span> za zajem, integracijo, hrambo in\n" +
                    "                obdelavo masovnih podatkov, interaktivno analitiko in\n" +
                    "                vizualizacijo, upravljanje z internetom stvari, razvoj\n" +
                    "                nadzornih plošč, razvoj digitalnih tržnic, upravljanje s\n" +
                    "                programskimi vmesniki in podobne rešitve.";
            }
        }

    }
</script>

<style lang="scss" scoped>
    .igrala-background {
        background-color: $igrala-background;
    }

    .igrala-title {
        text-align: center;
        margin-bottom: 1vh;
    }

    .igrala-features {
        padding-top: 3vh;
        padding-left: 10px;
    }

    @media (min-width: 992px) {
        .igrala-desc-offset {
            padding-left: 40px;
            padding-right: 2vw;
        }
    }
</style>
